import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block text-xs font-medium text-primary-500 border border-primary-500/30 px-4 py-1.5 rounded-full mb-4">
            {t('home:categories.title')}
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            {t('home:categories.heading')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {t('home:categories.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group block bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 hover:bg-accent-500 hover:border-accent-500 cursor-pointer transition-all duration-300"
            >
              <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${cat.color} mb-5 group-hover:bg-background-50/20 group-hover:text-background-50 transition-all duration-300`}>
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground-950 group-hover:text-background-50 mb-2 transition-colors duration-300">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 group-hover:text-background-50/70 transition-colors duration-300 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm font-medium text-foreground-700 group-hover:text-background-50 transition-colors duration-300">
                <span>进入频道</span>
                <i className="ri-arrow-right-line text-xs group-hover:translate-x-1 transition-transform duration-300"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}